<mat-card>

  <mat-card-content>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <mat-card-header style="padding: 0;">
          <mat-card-title style="white-space:nowrap;">{{premiseRow.address}}</mat-card-title>
          <mat-card-subtitle style="white-space:nowrap;">{{premiseRow.postcode}}</mat-card-subtitle>
        </mat-card-header>
      </div>

      <div class="col-12 col-sm-6 col-md-3 mb-3 mat-body">
        <div style="display: flex; flex-direction: row; gap: 10px;">
          <div>
            @for (premiseDetail of premiseRow.premiseDetails; track premiseDetail) {
              <div>
                <span style="white-space:nowrap;" [matTooltip]="premiseDetail.toolTip">{{premiseDetail.displayName}}</span>
              </div>
            }
          </div>
          <div>
            @for (premiseDetail of premiseRow.premiseDetails; track premiseDetail) {
              <div>
                <span>{{premiseDetail.value}}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-6 mb-3">
        <div style="display: flex; flex-direction: row; align-items: flex-start;">
          <div style="margin-right: 20px;">
            <button mat-stroked-button (click)="openDialog()">Edit Premise</button>
          </div>
          <div style="font-size: 11px; color: grey; font-weight: 500;">
            <div>
              <span>Created</span>
              <span style="padding-left: 17px;">{{premiseRow.createdDate | date:'dd MMM y HH:mm'}}</span>
            </div>
            <div>
              <span>Modified</span>
              <span style="padding-left: 10px;">{{premiseRow.modifiedDate | date:'dd MMM y HH:mm'}}</span>
            </div>
            @if (premiseRow.deletedDate !== null) {
              <div style="color: red;margin-top: 7px;">
                <span>Deleted</span>
                <span style="padding-left: 17px;">{{premiseRow.deletedDate | date:'dd MMM y HH:mm'}}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>

  @if (!premiseRow.storeConfigs || !premiseRow.storeConfigs.length) {
    <div>
      <div class="mat-small" style="color: red;">No Service Cover is found for this premise. Please check Service Cover exists is
        the Back Office system
      </div>
    </div>
  }

  @for (storeConfig of premiseRow.storeConfigs; track storeConfig; let i = $index) {
    <div>
      <app-store-config [premiseFlat]="getPremiseFlat(storeConfig)"></app-store-config>
    </div>
  }

  @if (isLoading) {
    <div class="loading-shade">
      @if (isLoading) {
        <mat-spinner></mat-spinner>
      }
    </div>
  }
</mat-card>
